import { combineReducers } from 'redux';

import { searchReducer } from './searchReducer';
import { itemReducer } from './itemReducer';
import { materialReducer } from './materialReducer';
import { libraryReducer } from './libraryReducer';
import { repositoryReducer } from './repositoryReducer';

export const Reducers = combineReducers({
  search: searchReducer,
  item: itemReducer,
  material: materialReducer,
  library: libraryReducer,
  repository: repositoryReducer,
});